module.exports = __webpack_public_path__ + "static/MonumentExtended-Ultrabold-5cc3087dc0b0a75ff38e0ba32c185c3e.woff2";